import axios from "axios";
import { BASE_URL } from "../Global";
import useAuthStore from "../Store/AuthStore";

// Fetch Events API
export const fetchEventsAPI = async () => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.post(
            `${BASE_URL}/api/user/events`,
            {
                email,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// Add Event API
export const addEventAPI = async (event, space, type) => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.post(
            `${BASE_URL}/api/user/event-space`,
            { type, event, email, space },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// Delete Event API
export const deleteEventAPI = async (type, name) => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.put(
            `${BASE_URL}/api/user/events-spaces/delete`,
            {
                email,
                name,
                type,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// fetch Featured Event API
export const fetchFeaturedEventsAPI = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/api/user/upcoming-events`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error) {
        return error;
    }
};

// fetch Event or Space Details API
export const fetchEventOrSpaceDetailsAPI = async (type, name) => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.post(
            `${BASE_URL}/api/user/gifts/${type}/${name}`,
            { email },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// Add Gift to Event or Space API
export const AddGiftToEventOrSpaceAPI = async (type, name, giftID) => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.put(
            `${BASE_URL}/api/user/events/update/add`,
            { type, giftID: giftID, name, email },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// Delete Gift from Event or Space API
export const DeleteGiftFromEventOrSpaceAPI = async (type, name, giftID) => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.put(
            `${BASE_URL}/api/user/events/update/delete`,
            { type, giftID: giftID, name, email },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// Edit Gift from Event or Space API
export const EditGiftFromEventOrSpaceAPI = async (type, name, updatedData) => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.put(
            `${BASE_URL}/api/user/update/${name}`,
            { type, name, updatedData, email },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};
